/**
 * A set of standard HTTP status codes
 */
export enum StatusCode {
  Success = 200,
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  InternalServerError = 500,
}

/**
 * A map of status codes and a default message
 */
const StatusCodeMessageMap: Record<StatusCode, string> = {
  [StatusCode.Success]: 'Success',
  [StatusCode.BadRequest]: 'Bad Request',
  [StatusCode.Unauthorized]: 'Unauthorized',
  [StatusCode.Forbidden]: 'Forbidden',
  [StatusCode.NotFound]: 'Not Found',
  [StatusCode.InternalServerError]: 'Internal Server Error',
}

/**
 * Returns the default message for a given status code
 */
export function getDefaultStatusMessage(status: StatusCode) {
  return StatusCodeMessageMap[status]
}
